// extracted by mini-css-extract-plugin
export default {"wrapper":"MainTable_wrapper__yC6jC"};